import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoAccountsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_accounts"}/>
}
